import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/common";

export const RequireAuth = ({ children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Spinner />;
  if (!user) return <Navigate to="/signin" replace state={{ from: loc.pathname }} />;
  return children;
};

export const RequireMember = ({ children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Spinner />;
  if (!user) return <Navigate to="/signin" replace state={{ from: loc.pathname }} />;
  if (user.status !== "approved") return <Navigate to="/status" replace />;
  if (!user.profile_complete) return <Navigate to="/welcome" replace />;
  return children;
};

export const RequireAdmin = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  if (!user || user.role !== "admin" || user.status !== "approved") return <Navigate to="/" replace />;
  return children;
};
